export default "__VITE_ASSET__Bhy3NUYj__"